<select #select class="selectpicker ch-header-item fa" (change)="itemSelected($event)">
  <option *ngFor="let item of items" value="{{ item.value }}" [selected]="value == item.value">{{ item.name }}</option>
</select>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/widgets/select-picker/select-picker.component.html